import common from "../../utill/Common";

class WalletService {
  addTransaction = async (
    token,
    id,
    txn_type,
    wallet_type,
    amount,
    reference_id,
    remark
  ) => {
    const url = common.baseUrl + "user/wallet/add_transaction";

    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: JSON.stringify({
        id,
        txn_type,
        wallet_type,
        amount,
        reference_id,
        remark,
      }),
    };

    const response = await fetch(url, options);

    return response.json();
  };

  resellerUsersTotalBalance = async (token) => {
    const url = common.baseUrl + "user/wallet/reseller_users_total_balance";

    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: null,
    };

    const response = await fetch(url, options);

    return response.json();
  };

  defaultPG = async (token) => {
    const url = common.baseUrl + "user/pg/default_pg";

    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: null,
    };

    const response = await fetch(url, options);

    return response.json();
  };

  txnStatus = async (token, order_id) => {
    const url = common.baseUrl + "user/pg/txn_status";

    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: JSON.stringify({
        order_id,
      }),
    };

    const response = await fetch(url, options);

    return response.json();
  };

  upiGatawayCreateOrder = async (token, amount, redirect_url) => {
    const url = common.baseUrl + "user/pg/upi_gateway/create_order";

    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: JSON.stringify({
        amount,
        redirect_url,
      }),
    };

    const response = await fetch(url, options);

    return response.json();
  };

  allInOneUpiGatawayCreateOrder = async (token, amount) => {
    const url = common.baseUrl + "user/pg/all_in_one_upi_gateway/create_order";

    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: JSON.stringify({
        amount,
      }),
    };

    const response = await fetch(url, options);

    return response.json();
  };

  bpAddMoney = async (token, amount) => {
    const url = common.baseUrl + "user/pg/bp_add_money";

    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: JSON.stringify({
        amount,
      }),
    };

    const response = await fetch(url, options);

    return response.json();
  };

  bpCheckStatus = async (token, rrn) => {
    const url = common.baseUrl + "user/pg/bp_check_status";

    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: JSON.stringify({
        rrn,
      }),
    };

    const response = await fetch(url, options);

    return response.json();
  };

  walletStatement = async (token, fromDate, toDate, searchText, page, size) => {
    const url = common.baseUrl + "user/history/wallet";

    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: JSON.stringify({
        from_date: fromDate,
        to_date: toDate,
        search_text: searchText,
        page: page,
        size: size,
      }),
    };

    const response = await fetch(url, options);

    return response.json();
  };

  xlsWalletStatement = async (token, fromDate, toDate) => {
    const url = common.baseUrl + "user/history/xls_wallet_statement";

    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: JSON.stringify({
        from_date: fromDate,
        to_date: toDate,
      }),
    };

    const response = await fetch(url, options);

    return response.json();
  };

  commissionSummary = async (token, fromDate, toDate, product_id) => {
    const url = common.baseUrl + "user/report/commission";

    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: JSON.stringify({
        from_date: fromDate,
        to_date: toDate,
        product_id: product_id,
      }),
    };

    const response = await fetch(url, options);

    return response.json();
  };

  productList = async (token) => {
    const url = common.baseUrl + "user/products/fetch";

    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: null,
    };

    const response = await fetch(url, options);

    return response.json();
  };

  fundRequestHistory = async (
    token,
    fromDate,
    toDate,
    searchText,
    page,
    size
  ) => {
    const url = common.baseUrl + "user/fund_request/history";

    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: JSON.stringify({
        from_date: fromDate,
        to_date: toDate,
        search_text: searchText,
        page: page,
        size: size,
      }),
    };

    const response = await fetch(url, options);

    return response.json();
  };

  walletTransferHistory = async (
    token,
    fromDate,
    toDate,
    searchText,
    page,
    size
  ) => {
    const url = common.baseUrl + "user/report/wallet_transfer";

    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: JSON.stringify({
        from_date: fromDate,
        to_date: toDate,
        search_text: searchText,
        page: page,
        size: size,
      }),
    };

    const response = await fetch(url, options);

    return response.json();
  };

  walletReceivedHistory = async (
    token,
    fromDate,
    toDate,
    searchText,
    page,
    size
  ) => {
    const url = common.baseUrl + "user/report/wallet_received";

    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: JSON.stringify({
        from_date: fromDate,
        to_date: toDate,
        search_text: searchText,
        page: page,
        size: size,
      }),
    };

    const response = await fetch(url, options);

    return response.json();
  };
}

// eslint-disable-next-line import/no-anonymous-default-export
export default new WalletService();
